function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module html-embed/inserthtmlembedcommand
 */
import { Command } from 'ckeditor5/src/core';
import { findOptimalInsertionPosition, checkSelectionOnObject } from 'ckeditor5/src/widget';
/**
 * The insert HTML embed element command.
 *
 * The command is registered by {@link module:html-embed/htmlembedediting~HtmlEmbedEditing} as `'insertHtmlEmbed'`.
 *
 * To insert the HTML embed element at the current selection, execute the command:
 *
 *		editor.execute( 'insertHtmlEmbed' );
 *
 * @extends module:core/command~Command
 */

var InsertHtmlEmbedCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(InsertHtmlEmbedCommand, _Command);

  function InsertHtmlEmbedCommand() {
    _classCallCheck(this, InsertHtmlEmbedCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(InsertHtmlEmbedCommand).apply(this, arguments));
  }

  _createClass(InsertHtmlEmbedCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      this.isEnabled = isHtmlEmbedAllowed(this.editor.model);
    }
    /**
     * Executes the command, which creates and inserts a new HTML embed element.
     *
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      model.change(function (writer) {
        var rawHtmlElement = writer.createElement('rawHtml');
        model.insertContent(rawHtmlElement);
        writer.setSelection(rawHtmlElement, 'on');
      });
    }
  }]);

  return InsertHtmlEmbedCommand;
}(Command); // Checks if the `htmlEmbed` element can be inserted at the current model selection.
//
// @param {module:engine/model/model~Model} model
// @returns {Boolean}


export { InsertHtmlEmbedCommand as default };

function isHtmlEmbedAllowed(model) {
  var schema = model.schema;
  var selection = model.document.selection;
  return isHtmlEmbedAllowedInParent(selection, schema, model) && !checkSelectionOnObject(selection, schema);
} // Checks if an HTML embed is allowed by the schema in the optimal insertion parent.
//
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/model/model~Model} model Model instance.
// @returns {Boolean}


function isHtmlEmbedAllowedInParent(selection, schema, model) {
  var parent = getInsertPageBreakParent(selection, model);
  return schema.checkChild(parent, 'rawHtml');
} // Returns a node that will be used to insert a page break with `model.insertContent` to check if a html embed element can be placed there.
//
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// @param {module:engine/model/model~Model} model Model instance.
// @returns {module:engine/model/element~Element}


function getInsertPageBreakParent(selection, model) {
  var insertAt = findOptimalInsertionPosition(selection, model);
  var parent = insertAt.parent;

  if (parent.isEmpty && !parent.is('element', '$root')) {
    return parent.parent;
  }

  return parent;
}